import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useMemo } from "preact/hooks"
import { filterOrder, lumberFinishFilters, tier3Map } from "../../config"
import { sortFilters } from "../../helpers"

export default function FilterDropDownList({ facet }) {
    const { toggleProductFilter } = useFacet(facet)
    const isLumberFinish = useMemo(() => facet.name === "Lumber Finish", [])
    const isTier3 = useMemo(() => facet.field === "customFields.metafields-marketing_category_tier_3", [])
    
    return (
        <div 
            style={{
                maxHeight: '300px',
                width: '250px',
                overflowY: 'auto',
                overflowX: 'hidden',
                paddingRight: '0'
            }}
        >
            <ul 
                class="list-unstyled space-y-xs" 
                role="menu"
            >
                {(filterOrder[facet.name] 
                    ? sortFilters(facet.data, filterOrder[facet.name]) 
                    : facet.data
                )?.map(value => {
                    const valueName = value.value.replaceAll(' ', '-').trim().toLowerCase();
                    const inputId = `facet-${facet.id}-filter-${valueName}`;
                    const textId = `${inputId}-label`;
                    const filterValue = (isTier3 && tier3Map[value.value]) ? tier3Map[value.value] : value.value;
                    return (
                        <li
                            key={`${value.value}-${facet.id}`}
                            data-nosto-element="facet-setting"
                            role="menuitem"
                        >
                            <div class="flex items-center gap-xs [&mp;_input]:border-t-foreground py-1 group/checkbox has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-p-focus">
                                <label 
                                    htmlFor={inputId}
                                    class="relative flex items-center cursor-pointer"
                                >
                                    <input
                                        id={inputId}
                                        type="checkbox"
                                        class="relative transition-all border appearance-none cursor-pointer text-t-foreground-secondary hover:text-t-foreground disabled:border-t-border size-4 peer border-blue-gray-200 checked:border-t-foreground disabled:cursor-auto focus-visible:outline-0 rounded-[1px]" 
                                        checked={value.selected}
                                        value={filterValue}
                                        aria-labelledby={textId}
                                        onChange={e => {
                                            e.preventDefault()
                                            toggleProductFilter(facet.field, filterValue, !value.selected)
                                        }}
                                    />
                                    <span class="absolute transition-opacity opacity-0 pointer-events-none size-3 text-t-foreground top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100 peer-disabled:border-t-border peer-disabled:text-t-disabled">
                                        <svg fill="none" id="icon-checkbox-tick" viewBox="0 0 12 10">
                                            <path stroke="currentColor" d="M1 5.31 4.178 8.49 11 1.667"></path>
                                        </svg>
                                    </span>
                                </label>
                                <label
                                    htmlFor={inputId}
                                    class="mt-px cursor-pointer select-none text-t-foreground body-16 group-has-[:disabled]/checkbox:text-t-border group-has-[:disabled]/checkbox:cursor-auto"
                                >
                                     <div>
                                       <p
                                            id={textId}
                                            class="!capitalize !body-14 !text-t-foreground group-has-[:disabled]/checkbox:!text-t-disabled block body-16 leading-none text-t-foreground-secondary hover:text-t-foreground group-has-[:checked]/checkbox:text-t-foreground group-has-[:disabled]/checkbox:text-t-disabled"
                                        >
                                            {isLumberFinish ? lumberFinishFilters[value.value] : value.value} ({value.count})
                                        </p>
                                    </div>
                                </label>
                            </div>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}